/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Shot_Source_Detect_AutoInputs */



/**
* | output |
* | --- |
* | "Detect Automatically" |
*
* @param {Ad_Shot_Source_Detect_AutoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_shot_source_detect_auto = /** @type {((inputs?: Ad_Shot_Source_Detect_AutoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Shot_Source_Detect_AutoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détection automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Erkennung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rilevamento automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение автоматически")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detectar automáticamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动检测")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動検出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित रूप से पता लगाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detectar automaticamente")
	return /** @type {LocalizedString} */ ("Detect Automatically")
});